import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "enabled", "provider", "model", "section", "settings", "status" ]
  static values = { models: Object }

  connect() {
    this.update()
  }

  update() {
    this.updateEnabledState()
    this.updateModelOptions()
    this.updateProviderSections()
  }

  updateEnabledState() {
    const enabled = this.enabledTarget.checked

    this.settingsTargets.forEach((settings) => {
      settings.hidden = !enabled
    })

    this.statusTarget.textContent = enabled ? "Enabled" : "Disabled"
    this.statusTarget.classList.toggle("theme-success", enabled)
    this.statusTarget.classList.toggle("theme-secondary", !enabled)
  }

  updateModelOptions() {
    const catalog = this.modelsValue[this.providerTarget.value] || { default: null, models: [] }
    const currentModel = this.modelTarget.value
    const availableValues = catalog.models.map((model) => model.value)
    const selectedModel = availableValues.includes(currentModel) ? currentModel : catalog.default

    this.modelTarget.replaceChildren(
      ...catalog.models.map((model) => new Option(model.label, model.value, false, model.value === selectedModel))
    )
    this.modelTarget.disabled = catalog.models.length === 0

    if (window.$ && window.$(this.modelTarget).hasClass("select2-hidden-accessible")) {
      window.$(this.modelTarget).trigger("change.select2")
    }
  }

  updateProviderSections() {
    this.sectionTargets.forEach((section) => {
      const selected = section.dataset.provider === this.providerTarget.value
      const visible = this.enabledTarget.checked && selected
      section.hidden = !visible
      this.toggleInputs(section, selected)
    })
  }

  toggleInputs(section, visible) {
    section.querySelectorAll("input, select, textarea, button").forEach((element) => {
      if (visible) {
        if (element.dataset.assistantSettingsHiddenDisabled === "true") {
          element.disabled = false
          delete element.dataset.assistantSettingsHiddenDisabled
        }
      } else if (!element.disabled) {
        element.disabled = true
        element.dataset.assistantSettingsHiddenDisabled = "true"
      }
    })
  }
}
